import { render, staticRenderFns } from "./WebviewVideo.vue?vue&type=template&id=50e5b785"
import script from "./WebviewVideo.vue?vue&type=script&lang=js"
export * from "./WebviewVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports